import { render, staticRenderFns } from "./PageStackIndex.vue?vue&type=template&id=be72817a&scoped=true&"
import script from "./PageStackIndex.vue?vue&type=script&lang=js&"
export * from "./PageStackIndex.vue?vue&type=script&lang=js&"
import style0 from "./PageStackIndex.vue?vue&type=style&index=0&id=be72817a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be72817a",
  null
  
)

export default component.exports